module.exports = __webpack_public_path__ + "static/media/icons8-add.16c2161d.svg";